// src/pages/AppointmentPage/AppointmentPage.tsx

import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import taxReturnImage from "../../assets/tax_return.jpg";
import taxPlanningImage from "../../assets/tax_planning.jpg";
import newClientImage from "../../assets/new_customer.jpg";
import styles from "./AppointmentPage.module.scss";

const AppointmentPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleSelectReview = () => {
    navigate("/appointment/annual-tax-return-review");
  };

  const handleSelectPlanning = () => {
    navigate("/appointment/personal-tax-planning");
  };

  const handleSelectNewClient = () => {
    navigate("/appointment/new-client-consulting");
  };

  return (
    <div className={styles["appointment-page"]}>
      <h2>{t("appointment.chooseYourAppointmentType")}</h2>
      <div className={styles["services-container"]}>
        <div className={`${styles["service-box"]} ${styles["hidden"]}`} onClick={handleSelectReview}>
          <img src={taxReturnImage} alt="Tax Return Review" />
          <h3>{t("appointment.annualTaxReturnReview")}</h3>
        </div>
        <div className={styles["service-box"]} onClick={handleSelectPlanning}>
          <img src={taxPlanningImage} alt="Personal Tax Planning" />
          <h3>{t("appointment.personalTaxPlanning")}</h3>
        </div>
        <div className={`${styles["service-box"]} ${styles["hidden"]}`} onClick={handleSelectNewClient}>
          <img src={newClientImage} alt="New Client Initial Consulting" />
          <h3>{t("appointment.newClientConsulting")}</h3>
        </div>
      </div>
    </div>
  );
};

export default AppointmentPage;
